import React, { useState, useEffect, useCallback } from "react";
import { useTranslation } from 'react-i18next';
import EditCompanyDialog from "./EditCompanyDialog";
import LanguageSelector from '../components/LanguageSelector';
import { assistantSupabase } from '../supabaseClient';
import { format, addDays } from "date-fns";
import { toZonedTime } from "date-fns-tz";
import es from 'date-fns/locale/es';
// import CompanyInfoDialog from "./CompanyInfoDialog";


const ChatAssistant = ({ isVeterinarian, userData, setUserData, companyData, setCompanyData }) => {
    const { t } = useTranslation();
    const [activeTab, setActiveTab] = useState("skills");
    const [selectedLanguage, setSelectedLanguage] = useState('es');

    const handleLanguageChangeCallback = useCallback((language) => {
        updateDefaultData(language).then(r => {});
    
    }, []);

    useEffect(() => {
        getDefaultData();
    
      }, []);
    
      const getDefaultData = async () => {
        const user = await assistantSupabase.from("user").select("*").eq("phone", "demo-user").eq("language_short_code", selectedLanguage)
        const company = await assistantSupabase.from("company").select("*").eq("phone", "demo").eq("language_short_code", selectedLanguage)
    
        if (user.data) {
          user.data[0]['info']['proximas_citas'][0] = user.data[0]['info']['proximas_citas'][0].replace("mañana", format(toZonedTime(addDays(new Date(), 1), "UTC"), "dd 'de' MMMM", { locale: es }))
          setUserData({
            nombre: user.data[0].info.nombre,
            dni: user.data[0].info.dni,
            fecha_nacimiento: user.data[0].info.fecha_nacimiento,
            seguro_medico: user.data[0].info.seguro_medico,
            historia_clinica: user.data[0].info.historia_clinica,
            notas: user.data[0].info.notas,
            citas_pasadas: user.data[0].info.citas_pasadas,
            proximas_citas: user.data[0].info.proximas_citas,
          })
        }
    
        if (company.data) {
          setCompanyData(company.data[0])
        }
      };

    const updateDefaultData = async (language) => {
        setSelectedLanguage(language);

        const user = await assistantSupabase.from("user").select("*").eq("phone", "demo-user").eq("language_short_code", language);
        const company = await assistantSupabase.from("company").select("*").eq("phone", "demo").eq("language_short_code", language);

        if (user.data) {
        user.data[0]['info']['proximas_citas'][0] = user.data[0]['info']['proximas_citas'][0].replace("mañana", format(toZonedTime(addDays(new Date(), 1), "UTC"), "dd 'de' MMMM", { locale: es }))
        setUserData({
            nombre: user.data[0].info.nombre,
            dni: user.data[0].info.dni,
            fecha_nacimiento: user.data[0].info.fecha_nacimiento,
            seguro_medico: user.data[0].info.seguro_medico,
            historia_clinica: user.data[0].info.historia_clinica,
            notas: user.data[0].info.notas,
            citas_pasadas: user.data[0].info.citas_pasadas,
            proximas_citas: user.data[0].info.proximas_citas,
        })
        }

        if (company.data) {
        setCompanyData(company.data[0]);
        }
    }

    return (
        <div className="w-2/4 flex flex-col justify-center items-center">
            <div className="flex w-full">
                <button
                    onClick={() => setActiveTab("skills")}
                    className={`flex-1 py-2 text-center font-semibold rounded-tl-sm ${activeTab === "skills" ? "bg-[#34a4d0] text-white" : "bg-gray-200 text-gray-700"
                        }`}
                >
                    {t("skills_tab_title")}
                </button>
                <button
                    onClick={() => setActiveTab("client")}
                    className={`flex-1 py-2 text-center font-semibold rounded-tr-sm ${activeTab === "client" ? "bg-[#34a4d0] text-white" : "bg-gray-200 text-gray-700"
                        }`}
                >
                    {t("client_info_tab_title")}
                </button>
            </div>
            <div className="bg-white px-8 py-6 rounded-sm w-full">
                {activeTab === "skills" ? (
                    <>
                        <h2 className="text-3xl font-bold text-[#34a4d0] mb-4">¿Qué puedo hacer por ti?</h2>
                        <p className="text-sm text-gray-700 mb-4">
                        Soy capaz de navegar por todo el sistema, asumir la mayoría de tareas del operador del call center y gestionar tanto llamadas entrantes como salientes. Aquí tienes explicado de forma más detallada mis habilidades:
                        </p>
                        <div className="mb-4">
                            <h3 className="text-md font-semibold text-gray-900">LLAMADAS</h3>
                            <ul className="list-none list-disc list-inside text-sm text-gray-700 ml-4">
                                <li>Realizo llamadas de forma empática adaptándome a la edad y perfil de la persona a la que me dirijo para completar cuestionarios sanitarios y seguimiento de pacientes de forma personalizada, estructurando la información de las respuestas en menos de 5 segundos.</li>
                            </ul>
                        </div>
                        <div className="mb-4">
                            <h3 className="text-md font-semibold text-gray-900">{t("intelligent_booking")}</h3>
                            <ul className="list-none list-disc list-inside text-sm text-gray-700 ml-4">
                                <li>Puedo crear citas basadas en la disponibilidad y las preferencias del paciente.</li>
                            </ul>
                        </div>
                        <div className="mb-4">
                            <h3 className="text-md font-semibold text-gray-900">WHATSAPP</h3>
                            <ul className="list-none list-disc list-inside text-sm text-gray-700 ml-4">
                                <li>Puedo enviar mensajes a través de WhatsApp para confirmar citas.</li>
                            </ul>
                        </div>
                        <div className="mb-4">
                            <h3 className="text-md font-semibold text-gray-900">{t("frequent_questions")}</h3>
                            <ul className="list-none list-disc list-inside text-sm text-gray-700 ml-4">
                                <li>Soy capaz de responder preguntas comunes sobre horarios, servicios, ubicaciones y políticas del hospital.</li>
                            </ul>
                        </div>
                        <div className="mb-4">
                            <h3 className="text-md font-semibold text-gray-900">{t("security_privacy")}</h3>
                            <ul className="list-none list-disc list-inside text-sm text-gray-700 ml-4">
                                <li>No tengo la capacidad de compartir información sensible o privada.</li>
                            </ul>
                        </div>
                        <div className="mb-4">
                            <h3 className="text-md font-semibold text-gray-900">{t("demo")}</h3>
                            <ul className="list-none list-disc list-inside text-sm text-gray-700 ml-4">
                                <li>Esto se trata de una simulación en un entorno de pruebas, por lo que las acciones que realice no tendrán efectos reales.</li>
                            </ul>
                        </div>
                        {/* <CompanyInfoDialog
                            company={companyData}
                        ></CompanyInfoDialog> */}
                    </>
                ) : (
                    <>
                        {isVeterinarian ? (
                            <>
                                <h2 className="text-2xl font-bold text-[#34a4d0] mb-4">
                                    {userData?.nombre}
                                </h2>
                                <div className="mb-2">
                                    <h3 className="text-lg font-semibold text-gray-900">{t("owner_information_title")}</h3>
                                    <ul className="list-none list-disc list-inside text-sm text-gray-700 ml-4">
                                        <li>{t("owner_phone", { phone: userData['phone'] || '' })}</li>
                                    </ul>
                                </div>
                                <div className="mb-2">
                                    <h3 className="text-lg font-semibold text-gray-900">{t("pet_information_title")}</h3>
                                    <ul className="list-none list-disc list-inside text-sm text-gray-700 ml-4">
                                        <li>{t("pet_name", { name: "Congo" })}</li>
                                        <li>{t("pet_breed", { breed: "Caniche" })}</li>
                                        <li>{t("pet_sex", { sex: "Macho" })}</li>
                                        <li>{t("pet_age", { age: "13 años y 6 meses" })}</li>
                                        <li>{t("pet_passport_number", { passport: "ES012929737" })}</li>
                                        <li>{t("pet_microchip", { microchip: "941000022590412" })}</li>
                                        <li>{t("pet_hospitalized", { hospitalized: "No" })}</li>
                                    </ul>
                                </div>
                                <div className="mb-2">
                                    <h3 className="text-lg font-semibold text-gray-900">{t("pet_history_title")}</h3>
                                    <p className="text-sm text-gray-700 ml-4">{t("pet_history_description")}</p>
                                </div>
                                <div className="mb-2">
                                    <h3 className="text-lg font-semibold text-gray-900">{t("past_appointments_title")}</h3>
                                    <ul className="list-none list-disc list-inside text-sm text-gray-700 ml-4">
                                        <li>{t("past_appointment_1")}</li>
                                        <li>{t("past_appointment_2")}</li>
                                        <li>{t("past_appointment_3")}</li>
                                        <li>{t("past_appointment_4")}</li>
                                        <li>{t("past_appointment_5")}</li>
                                        <li>{t("past_appointment_6")}</li>
                                    </ul>
                                </div>
                                <div>
                                    <h3 className="text-lg font-semibold text-gray-900">{t("upcoming_appointments_title")}</h3>
                                    <ul className="list-none list-disc list-inside text-sm text-gray-700 ml-4">
                                        <li>{t("upcoming_appointment_1")}</li>
                                        <li>{t("upcoming_appointment_2")}</li>
                                    </ul>
                                </div>
                            </>
                        ) : (
                            <>
                                <h2 className="text-2xl font-bold text-[#34a4d0] mb-4">
                                    Manuel Fernández Rodríguez
                                </h2>
                                <div className="text-sm text-gray-700">
                                    <section className="mb-6">
                                        <h3 className="text-lg font-semibold text-gray-900">Datos del paciente</h3>
                                        <ul className="list-disc list-inside ml-4 space-y-1">
                                            <li><strong>Edad:</strong> 58 años</li>
                                            <li><strong>Sexo:</strong> Masculino</li>
                                            <li><strong>Ocupación:</strong> No especificada</li>
                                            <li><strong>Grupo sanguíneo:</strong> O positivo</li>
                                        </ul>
                                    </section>
                                    <section className="mb-6">
                                        <h3 className="text-lg font-semibold text-gray-900">Antecedentes personales</h3>
                                        <ul className="list-disc list-inside ml-4 space-y-1">
                                            <li>Fumador</li>
                                            <li>Sin antecedentes de enfermedades respiratorias conocidas</li>
                                            <li>Hipertensión arterial diagnosticada a los 50 años, en tratamiento con enalapril 10 mg diarios</li>
                                            <li>Cirugía de apendicectomía a los 17 años</li>
                                            <li>Sin alergias medicamentosas conocidas</li>
                                            <li>Vacunación antigripal anual</li>
                                        </ul>
                                    </section>
                                    <section className="mb-6">
                                        <h3 className="text-lg font-semibold text-gray-900">Tratamiento habitual</h3>
                                        <ul className="list-disc list-inside ml-4 space-y-1">
                                            <li>Enalapril 10 mg/día</li>
                                            <li>Sin otros tratamientos crónicos referidos</li>
                                        </ul>
                                    </section>
                                    <section className="mb-6">
                                        <h3 className="text-lg font-semibold text-gray-900">Enfermedades crónicas</h3>
                                        <ul className="list-disc list-inside ml-4 space-y-1">
                                            <li>Hipertensión arterial</li>
                                        </ul>
                                    </section>
                                    <section className="mb-6">
                                        <h3 className="text-lg font-semibold text-gray-900">Pruebas complementarias recientes</h3>
                                        <ul className="list-disc list-inside ml-4 space-y-1">
                                            <li>Radiografía de tórax con sospecha de masa pulmonar</li>
                                        </ul>
                                    </section>
                                </div>
                            </>
                        )}

                    </>
                )}
            </div>
        </div>
    );
};

export default ChatAssistant;
